export const getBaseUrl = () => {
  try {
    return window.location.origin;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
    return 'https://dashboard-qa.ideal4finance.co.uk';
  }
};
